export default __webpack_public_path__ + "static/media/loading.51521bcf.gif";